<div (click)="onModalClick($event)">
  <div
    class="tw-flex tw-justify-start tw-h-10 tw-p-5 ltr:tw-dir-ltr rtl:tw-dir-rtl"
  >
    <i
      class="mdi mdi-close tw-cursor-pointer tw-text-gray-200 hover:!tw-text-red-400 tw-text-5xl tw-font-medium"
      (click)="onClose()"
    ></i>
  </div>

  <div class="tw-mx-2 sm:tw-mt-24">
    <div class="tw-h-[520px] tw-flex tw-justify-between tw-items-center">
      <!--#region next btn-->
      <div class="tw-w-12 tw-h-12 image-btn">
        <i
          *ngIf="!isNextImageDisabled"
          class="mdi mdi-chevron-right tw-cursor-pointer tw-text-5xl tw-text-gray-500 dark:!tw-text-gray-400 hover:!tw-text-gray-300"
          (click)="nextImage()"
        ></i>
      </div>
      <!--endregion-->

      <!--#region profile image-->
      <div class="tw-flex tw-flex-col tw-items-center">
        <div class="tw-object-cover tw-flex-center tw-relative">
          <img
            class="sm:tw-max-h-[70%] sm:tw-max-w-[70%] tw-max-w-64 tw-max-h-64 tw-object-cover"
            [src]="apiUrl + '/' + imageUrl"
          />
        </div>

        <!-- imageTitle -->
        <span
          class="tw-text-gray-300 tw-opacity-80 sm:tw-text-lg tw-text-sm tw-font-medium tw-mt-4 tw-whitespace-nowrap"
          >{{ imageTitle }}</span
        >
      </div>
      <!--endregion-->

      <!--#region previous btn-->
      <div class="tw-w-12 tw-h-12 image-btn">
        <i
          *ngIf="!isPreviousImageDisabled"
          class="mdi mdi-chevron-left tw-cursor-pointer tw-text-5xl tw-text-gray-500 dark:!tw-text-gray-400 hover:!tw-text-gray-300"
          (click)="previousImage()"
        ></i>
      </div>
      <!--endregion-->
    </div>
  </div>
</div>
